import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.70743 12.8963C2.31406 12.8887 1.98878 12.8017 1.73158 12.6353C1.47439 12.4689 1.28149 12.2533 1.15289 11.9885C1.03185 11.7237 0.982681 11.4438 1.00537 11.1488C1.03563 10.8538 1.13776 10.5777 1.31174 10.3205C1.4933 10.0633 1.75428 9.85526 2.09469 9.6964L20.2499 1.3223C20.7189 1.10292 21.1501 1.01215 21.5435 1.04997C21.9368 1.08779 22.2621 1.22774 22.5193 1.46981C22.7841 1.70431 22.9392 2.01447 22.9846 2.40026C23.0375 2.78606 22.9543 3.22103 22.7349 3.70517L14.3722 21.7696C14.2057 22.1327 13.9864 22.4126 13.714 22.6093C13.4493 22.806 13.1656 22.9195 12.863 22.9497C12.568 22.98 12.2881 22.9308 12.0233 22.8022C11.7586 22.6812 11.543 22.4883 11.3766 22.2235C11.2101 21.9663 11.1269 21.6448 11.1269 21.259L11.1042 13.1232C11.1042 12.987 11.0361 12.919 10.9 12.919L2.70743 12.8963Z" />
</svg>

`;

export const Location = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
